//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Header from './owner_submint_head';
import { Tab, Tabs, Switch  } from "vant";
import { Rate } from 'vant';
import { Popup } from 'vant';
export default {
  components:{
    [Popup.name]: Popup,
    [Rate.name]: Rate,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,  
    [Switch.name]: Switch,
    // "app-header":Header,
  },data() {
    return {
    }
      
  },
  methods: {
    onClick(index, title) {
    }
  }
    
}



// WEBPACK FOOTER //
// ./src/components/repairComponents/repairsTwo.vue